import { render, staticRenderFns } from "./VuePlainPagination.vue?vue&type=template&id=366404a2&scoped=true&"
import script from "./VuePlainPagination.vue?vue&type=script&lang=js&"
export * from "./VuePlainPagination.vue?vue&type=script&lang=js&"
import style0 from "./VuePlainPagination.vue?vue&type=style&index=0&id=366404a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366404a2",
  null
  
)

export default component.exports